import { apiGet } from '../../Dataman';
import { DEALS_PATHS } from './deals_paths';

export const basecampApiAdapter = {
  basecamp: {
    getProjects: (params) => apiGet(DEALS_PATHS.basecampProjects, { params }),
    getTodoLists: (bucket, params) =>
      apiGet(`${DEALS_PATHS.basecampProjects}/${bucket}${DEALS_PATHS.basecampTodoListsSuffix}`, { params }),
    getUsers: (bucket, params) =>
      apiGet(`${DEALS_PATHS.basecampProjects}/${bucket}${DEALS_PATHS.basecampUsersSuffix}`, { params }),
  },
};
